import Decimal from "decimal.js";

/** Clamps the given value between min and max. */
export const clamp = (value: Decimal, min: Decimal, max: Decimal) => Decimal.max(min, Decimal.min(max, value));
